import React, { useState } from "react";
import { useSelector } from "react-redux";
import { store } from "../../redux/configure-store";
import { Expendable } from "../../interfaces/expendable";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import {
  deleteCharacterExpendables,
  updateCharacterExpendables,
} from "../../api/expenndables-api";
import { ExpendableAction } from "../../redux/reducers/expendables-reducer";
import { Grid, TextField } from "@mui/material";
import { ExpendableType } from "../../enum/expendable-type";
import {
  AddCircleOutline,
  Delete,
  RemoveCircleOutline,
} from "@mui/icons-material";
import { useSpellStyles } from "../spells/spell-styles";

interface expendableProps {
  id: string | number;
  expType: ExpendableType | undefined;
  qty: number;
  description: string;
  addingNew: boolean;
}

export const ExpendableBar: React.FC<expendableProps> = (
  props: expendableProps
): JSX.Element => {
  const { id, expType, qty, description } = props;
  const [isEditing, setIsEditing] = useState(false);
  const char = useSelector((state) => store.getState().character);
  const { classes } = useSpellStyles();
  const [editDesc, setEditDesc] = useState(description);
  const userId = useSelector(() => store.getState().user.id);
  const charUserId = useSelector(() => store.getState().character.userID);

  const adjustExpCount = async (val: number) => {
    if (props.addingNew) {
      return;
    }
    if (qty + val < 0) {
      return;
    }
    const exp: Expendable = {
      charID: +char.charID,
      id: id,
      qty: qty + val,
      description,
      expType,
    };
    await updateCharacterExpendables(char.charID.toString(), exp);
    store.dispatch(ExpendableAction.updateSingleExpendable(exp));
  };
  const trashExpendable = async (id: string) => {
    const newList = await deleteCharacterExpendables(
      id,
      char.charID.toString()
    );
    store.dispatch(ExpendableAction.setExpendable(newList));
  };

  const updateSelectedRow = async () => {
    const theExp: Expendable = {
      ...props,
      charID: char.charID,
      description: editDesc,
    };
    await updateCharacterExpendables(char.charID.toString(), theExp);
    store.dispatch(ExpendableAction.updateSingleExpendable(theExp));
    setIsEditing(false);
  };
  return (
    <>
      <Grid
        direction={"row"}
        container
        className="standardRow"
        style={{ textAlign: "left", padding: "8px", alignItems: "center" }}
      >
        <Grid item alignContent="flex-start" xs={7} flexGrow={1}>
          {isEditing ? (
            <TextField
              style={{ display: "flex", flexGrow: "1", paddingRight: "12px" }}
              value={editDesc}
              onChange={(evt) => setEditDesc(evt.target.value)}
              placeholder="Spell Name"
              className={classes.inputField}
            />
          ) : (
            editDesc
          )}
        </Grid>
        <Grid item xs={3}>
          {expType}
        </Grid>
        <Grid container direction="row" item xs={2}>
          <Grid item flexShrink={1}>
            {charUserId === +userId && (
              <RemoveCircleOutline
                style={{
                  cursor: props.addingNew ? "auto" : "pointer",
                  padding: "5px 6px",
                  opacity: props.addingNew ? 0.6 : 1,
                }}
                sx={{ fontSize: 16 }}
                onClick={() => adjustExpCount(-1)}
              />
            )}
          </Grid>
          <Grid>{qty}</Grid>
          <Grid item flexShrink={1}>
            {charUserId === +userId && (
              <AddCircleOutline
                style={{
                  cursor: "pointer",
                  padding: "5px 6px",
                  opacity: props.addingNew ? 0.6 : 1,
                }}
                sx={{ fontSize: 16 }}
                onClick={() => adjustExpCount(1)}
              />
            )}
          </Grid>
        </Grid>
        {/* <Grid item flexShrink={1}> <PushPinIconOutlined style={{cursor:'pointer'}}></PushPinIconOutlined></Grid> */}
        <Grid item flexShrink={1} paddingRight="0.5rem">
          {isEditing ? (
            <SaveIcon
              style={{ cursor: "pointer" }}
              onClick={() => updateSelectedRow()}
            ></SaveIcon>
          ) : null}
          {!isEditing && charUserId === +userId && (
            <EditIcon
              style={{ cursor: "pointer" }}
              onClick={() => setIsEditing((val) => !val)}
            ></EditIcon>
          )}
        </Grid>
        {charUserId === +userId && (
          <Grid item flexShrink={1}>
            <Delete
              style={{ cursor: "pointer" }}
              onClick={() => trashExpendable(id.toString())}
            ></Delete>
          </Grid>
        )}
      </Grid>
    </>
  );
};
